import { render } from "./UserInfoSection.vue?vue&type=template&id=35b7f24b&scoped=true"
import script from "./UserInfoSection.vue?vue&type=script&lang=js"
export * from "./UserInfoSection.vue?vue&type=script&lang=js"

import "./UserInfoSection.vue?vue&type=style&index=0&id=35b7f24b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b7f24b"]])

export default __exports__